
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

const getAll = async (fields = ['id', 'descripcion', 'codEsp']) => {
  const queryFields = fields.join(',');

  const query = `
    query {
      allEspecialidad {
        ${queryFields}
      }
    }
  `;

  try {
    const response = await axios.post(rutas.axios + 'api', { query });
    const { data } = response
    return data.data.allEspecialidad;
  } catch (error) {
    console.error('An error occurred while fetching the options:', error);
  }
}


export const getOptionsSelect = async () => {
  // console.log('voy a solicitar especialidades al backend');
  const listEspecialidades = await getAll();

  return listEspecialidades.map(
    item => ({
      value: item.id,
      text : item.descripcion,
      codigo: item.codEsp
    })
  );
}










export const especialidadesService = {
  getOptionsSelect,
}
